import type {
	IGiftProvider,
	WeddingGuest,
	WeddingParty,
	IWishListItem
} from "~/types/supabase";
import type {
	PostgrestError
} from "@supabase/supabase-js";

export const useSupabase = () => {
	const getGiftProviders = async () => {
		return await $fetch<IGiftProvider[]>( "/api/supabase/giftProviders", {
			method: "GET",
			headers: {
				"Content-Type": "application/json"
			}
		} );
	};

	const getWishListItems = async () => {
		return await $fetch<IWishListItem[]>( "/api/supabase/wishListItems", {
			method: "GET",
			headers: {
				"Content-Type": "application/json"
			}
		} );
	};

	const updateWishListItem = async ( updatedItem: IWishListItem ) => {
		return await $fetch<IWishListItem>( "/api/supabase/wishListItems", {
			method: "PUT",
			headers: {
				"Content-Type": "application/json"
			},
			body: { updatedItem }
		} );
	};

	const findPartyByGuestName = async ( fullName: string ) => {
		return await $fetch<{ party: WeddingParty | null; guests: WeddingGuest[]; error: PostgrestError | null }>( "/api/supabase/rsvpParty", {
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: { fullName }
		} );
	};

	const updateGuestRsvps = async ( updatedGuests: WeddingGuest[] ) => {
		return await $fetch<{ updateResult: WeddingGuest[]; error: PostgrestError | null }>( "/api/supabase/guests", {
			method: "PUT",
			headers: {
				"Content-Type": "application/json"
			},
			body: { updatedGuests }
		} );
	};

	return {
		getGiftProviders,
		getWishListItems,
		updateWishListItem,
		findPartyByGuestName,
		updateGuestRsvps
	};
};